// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload {
  margin-top: 20px;
  margin-left: 5px;
  margin-right: 5px;
}

.labelcaricapres {
  font-size: large;
  margin-left: 15px;
  margin-top: -10px;
  margin-bottom: 10px;
}

.labelnotcsv {
  font-size: medium;
  margin-left: 15px;
  margin-top: -10px;
  margin-bottom: 10px;
  color: #C62828;
}

.footer {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  margin-left: 15px;
  width: 95%;
}

.studentiLabel {
  font-size: small;
  margin-top: -10px;
  margin-bottom: 10px;
  font-style: italic;
}

.studentiEmptyLabel {
  font-size: medium;
  margin-top: -10px;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/carica-presenze/carica-presenze.page.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,gBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AACJ;;AAEA;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;AACJ;;AAEA;EACI,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,iBAAA;EACA,mBAAA;AACJ","sourcesContent":[".upload {\n    margin-top: 20px;\n    margin-left: 5px;\n    margin-right: 5px;\n}\n\n.labelcaricapres {\n    font-size: large;\n    margin-left: 15px;\n    margin-top: -10px;\n    margin-bottom: 10px;\n}\n\n.labelnotcsv {\n    font-size: medium;\n    margin-left: 15px;\n    margin-top: -10px;\n    margin-bottom: 10px;\n    color: #C62828;\n}\n\n.footer {\n    margin-top: 20px;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 15px;\n    margin-left: 15px;\n    width: 95%;\n}\n\n.studentiLabel {\n    font-size: small;\n    margin-top: -10px;\n    margin-bottom: 10px;\n    font-style: italic;\n}\n\n.studentiEmptyLabel {\n    font-size: medium;\n    margin-top: -10px;\n    margin-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
